export default (apiType) => {
  console.log("====================================");
  console.log(
    `REACT_APP_${process.env.REACT_APP_NODE_ENV}_${apiType.toUpperCase()}_API`
  );
  console.log("====================================");
  return process.env[
    `REACT_APP_${process.env.REACT_APP_NODE_ENV}_${apiType.toUpperCase()}_API`
  ];
};
